module.exports = __webpack_public_path__ + "static/media/coffee.bc02fee1.gif";